var poll_default = {
  "fontElementMap": "_2mJIC",
  "container": "mTL98",
  "fullscreen": "FNcSg",
  "background_overlay": "M-qOA",
  "with_image": "SOcE-",
  "options": "fOOya",
  "webview": "PUhcN",
  "grid": "j8AHN",
  "option": "yE-cs",
  "cta_button": "yMZ8b",
  "add_option": "YjShc",
  "see_more": "n5NE1",
  "list": "q8-8z",
  "column": "kOuBp",
  "additional_note": "F2-Qk",
  "spinner": "Rj8sd",
  "spin": "Vulj8",
  "shown": "wb8fK",
  "error": "dmCJH"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
